import { IsOptional } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class ReceiptsDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "Projects id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "Projects Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  req_type: number;
  @ApiProperty()
  loanId: number;
  @ApiProperty()
  payment_date:Date;
  @ApiProperty()
  amount_paid:number;
  @ApiProperty()
  phone:string;
  @ApiProperty()
  executive:number;
  @ApiProperty()
  receipt_number:string;
  @ApiProperty()
  payment_mode:string;
  @ApiProperty()
  payment_type:string;
  @ApiProperty()
  cheque_number:string;
  @ApiProperty()
  @IsOptional()
  cheque_date:Date;
  @ApiProperty()
  @IsOptional()
  bank_name:string;
  @ApiProperty()
  @IsOptional()
  remarks:string;
  @ApiProperty()
  @IsOptional()
  bank_branch:string;
  @ApiProperty()
  @IsOptional()
  cheque_bank_branch:string;
  @ApiProperty()
  @IsOptional()
  service_charge_percentage:number;
  @ApiProperty()
  @IsOptional()
  service_charge_amount:number;
  @ApiProperty()
  @IsOptional()
  cheque_amount:number;
  @ApiProperty()
  @IsOptional()
  employeeId:number;
}